import { render, staticRenderFns } from "./TypeCategoryStats.vue?vue&type=template&id=00e9cb9d&scoped=true&"
import script from "./TypeCategoryStats.vue?vue&type=script&lang=js&"
export * from "./TypeCategoryStats.vue?vue&type=script&lang=js&"
import style0 from "./TypeCategoryStats.vue?vue&type=style&index=0&id=00e9cb9d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e9cb9d",
  null
  
)

export default component.exports